export let WEBGL_SUPPORTED = false;

export const checkWebGLSupport = () => {
  // Create canvas element. The canvas is not added to the
  // document itself, so it is never displayed in the
  // browser window.
  const canvas = document.createElement('canvas');

  // Get WebGLRenderingContext from canvas element.
  const gl = canvas.getContext('webgl');

  WEBGL_SUPPORTED = gl instanceof WebGLRenderingContext;
};
